/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-04-01 16:12:05
 * @FilePath: /vise/packages/app-share/src/constants/share.ts
 */

// 默认的分享策略数据，99.9%的用户都为此默认值
export const DEFAULT_GROWTHTEST_DATA = {
  collectionPullNew: false,
  collectionPullOld: true,
  collectionStyle: 1,
  dataSource: 0,
  ext: {},
  jumpMiniPlayer: 0,
  jumpNewPage: true,
  moduleDataSrc: 0,
  modulePullNew: false,
  modulePullOld: false,
  msg: 'succ',
  playBtnPullNew: false,
  playBtnPullOld: true,
  ret: 0,
  showModule: false,
  strategyID: '0',
};

export enum ECollectionStyle {
  oldUI = 1,   // 老UI
  newUI = 2    // 新UI
}
